/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type FindAction = {
  type: "find";
  pattern: string;
  url: string;
};

/** @internal */
export const FindAction$inboundSchema: z.ZodType<
  FindAction,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("find"),
  pattern: z.string(),
  url: z.string(),
});
/** @internal */
export type FindAction$Outbound = {
  type: "find";
  pattern: string;
  url: string;
};

/** @internal */
export const FindAction$outboundSchema: z.ZodType<
  FindAction$Outbound,
  z.ZodTypeDef,
  FindAction
> = z.object({
  type: z.literal("find"),
  pattern: z.string(),
  url: z.string(),
});

export function findActionToJSON(findAction: FindAction): string {
  return JSON.stringify(FindAction$outboundSchema.parse(findAction));
}
export function findActionFromJSON(
  jsonString: string,
): SafeParseResult<FindAction, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FindAction$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FindAction' from JSON`,
  );
}
